import React, { useState } from 'react';
import UIIconButton from '@/components/shared/UIIconButton';
import { ReactComponent as PaperclipIcon } from '@/img/button-icon-paperclip.svg';
import './UIChatInput.scss';

export interface UIChatInputProps {
  /**
   * Placeholder текст
   */
  placeholder?: string;

  /**
   * Значення поля вводу
   */
  value?: string;

  /**
   * Обробник зміни значення
   */
  onChange?: (value: string) => void;

  /**
   * Обробник відправки повідомлення
   */
  onSendMessage?: (message: string) => void;

  /**
   * Обробник прикріплення файлу
   */
  onAttachFile?: () => void;

  /**
   * Чи вимкнено поле
   */
  disabled?: boolean;

  /**
   * Розмір компонента
   */
  size?: 'small' | 'medium' | 'large';

  /**
   * Додатковий CSS клас
   */
  className?: string;
}

const baseClass = 'UIChatInput';

const UIChatInput: React.FC<UIChatInputProps> = ({
  placeholder = 'Type your message...',
  value = '',
  onChange = () => {},
  onSendMessage = () => {},
  onAttachFile = () => {},
  disabled = false,
  size = 'medium',
  className = '',
}) => {
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange(newValue);
  };

  const handleSendMessage = () => {
    if (inputValue.trim() && !disabled) {
      onSendMessage(inputValue.trim());
      setInputValue('');
      onChange('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const containerClasses = [
    baseClass,
    `${baseClass}--${size}`,
    disabled && `${baseClass}--disabled`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClasses}>
      <input
        type="text"
        className={`${baseClass}__input`}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        disabled={disabled}
      />

      <button
        type="button"
        className={`${baseClass}__attach-button`}
        onClick={onAttachFile}
        disabled={disabled}
      >
        <PaperclipIcon />
      </button>

      <UIIconButton
        iconType="go"
        variant="success"
        size={size === 'large' ? 'medium' : size}
        onClick={handleSendMessage}
        disabled={disabled || !inputValue.trim()}
        className={`${baseClass}__send-button`}
      />
    </div>
  );
};

export default UIChatInput;
